import { IconCheck2Outline18, IconXmarkOutline18 } from "nucleo-ui-outline-18"

import { Button } from "@productlane/ui"

import type { SuggestionProposal } from "./use-article-suggestions"
import { useBulkReviewActions } from "./use-bulk-review-actions"

export function ReviewBulkActions({
	proposals,
	articleId,
	discardedByProposal,
	hunkCountByProposal,
}: {
	proposals: SuggestionProposal[]
	articleId: string | null
	discardedByProposal?: Map<string, string[]>
	hunkCountByProposal?: Map<string, number>
}) {
	const { acceptAll, rejectAll, pending } = useBulkReviewActions({
		proposals,
		articleId,
		discardedByProposal,
		hunkCountByProposal,
	})

	if (proposals.length === 0) return null

	return (
		<div className="flex items-center gap-2">
			<Button
				variant="outline"
				onClick={rejectAll}
				isLoading={pending === "reject"}
				disabled={pending !== null}
				Icon={IconXmarkOutline18}
			>
				Reject all
			</Button>
			<Button
				onClick={acceptAll}
				isLoading={pending === "accept"}
				disabled={pending !== null}
				Icon={IconCheck2Outline18}
			>
				Accept all
			</Button>
		</div>
	)
}
